import { createSlice } from "@reduxjs/toolkit";

export const addProductWizardSlice = createSlice({
  name: "addProductWizard",
  initialState: {
    addProductMethod: "copyFromExisting",
    selectedProduct: null,
    recipeOptions: [],
    formData: {},
    selectedStage: null,
    isFormValid: false
  },
  reducers: {
    setAddProductMethod: (state, action) => {
      const { payload } = action;
      state.addProductMethod = payload;
    },
    setSelectedProduct: (state, action) => {
      const { payload } = action;
      state.selectedProduct = payload;
    },
    setRecipeOptions: (state, action) => {
      const { payload } = action;
      state.recipeOptions = payload;
    },
    setFormData: (state, action) => {
      const { payload } = action;
      state.formData = payload;
    },
    setSelectedStage: (state, action) => {
      const { payload } = action;
      state.selectedStage = payload;
    },
    setIsFormValid: (state, action) => {
      const { payload } = action;
      state.isFormValid = payload;
    },
  }
});

export const selectProductMethod = (state) => state.addProductWizard.addProductMethod;
export const selectSelectedProduct = (state) => state.addProductWizard.selectedProduct;
export const selectRecipeOptions = (state) => state.addProductWizard.recipeOptions;
export const selectFormData = (state) => state.addProductWizard.formData;
export const selectSelectedStage = (state) => state.addProductWizard.selectedStage;

export const {
  setAddProductMethod, setSelectedProduct, setRecipeOptions, setFormData, setSelectedStage, setIsFormValid
} = addProductWizardSlice.actions;

export default addProductWizardSlice.reducer;